import React, {Component, Fragment} from "react";
import * as R from "ramda";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import InventoryUnitTable from "../../common/InventoryUnitTable";
import InventoryUnitDetailHistory from "./InventoryUnitDetailHistory";
import Api from "../../../../../../Services/Api";
import {removeNullFields} from "../../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../../modules/popup/SimpleLoadingOverlay";
import { defaultTableChange } from "../../../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";

class InventoryUnitDetail extends Component {
    tableConfig = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {rowsPerPage} = tableMeta.tableState;
                    const rowNumber = 0 * rowsPerPage + tableMeta.rowIndex + 1;
                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "nosin",
            label: "No. Mesin",
            options: {
                sort: true,
            },
        },
        {
            name: "noka",
            label: "No. Rangka",
            options: {
                sort: true,
            },
        },
        {
            name: "rfsstatus",
            label: "RFS Status",
            options: {
                sort: true,
            },
        },
        {
            name: "selisihHari",
            label: "Umur",
            options: {
                sort: true,
            },
        },
        {
            name: "",
            label: "Aksi",
            options: {
                customBodyRender: (_, tableMeta) => (
                  <FlexView vAlignContent="center">
                    <SimpleButton
                      category="action_button"
                      icon={
                        <i
                          style={{ fontSize: 24, color: "red" }}
                          className="fa fa-lg fa-history"
                        />
                      }
                      onClick={() =>
                        this.handleModalHistoryVisibility(tableMeta.rowIndex)
                      }
                    />
                  </FlexView>
                ),
                sort: true,
            },
        },
    ]

    constructor(props) {
        super(props);
        this.initialSearch = {
            searchKey: null,
            searchValue: null,
        };
        this.state = {
            loading: false,
            dataTable: [],
            historyModalVisible: false,
            search: this.initialSearch,
            selectedData: null,
            pagination: {
                count: 5,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
        }
    }

    componentDidMount() {
        console.log("data:",this.props.selectedData);
        this.fetchDataUnitInfo({
            paramFilters: {
                kodeVariant: this.props.selectedData.kodeVariant,
                kodeWarna: this.props.selectedData.kodeWarna,
                locator: this.props.selectedData.kodeLokasi,
                idWarna: this.props.selectedData.idWarna,
            },
            limit: 5,
            page: 1
        });
    }

    handleModalHistoryVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: {
                ...prevValue.dataTable[index],
                kodeVariant: this.props.selectedData.kodeVariant,
                namaVariant: this.props.selectedData.namaVariant,
                kodeLokasi: this.props.selectedData.kodeLokasi,
            },
            historyModalVisible: !prevValue.historyModalVisible,
        }));
    }

    handleOnValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));

        if (R.equals(name, "searchKey") && R.isNil(value)) {
            this.setState((prevValue) => ({
                ...prevValue,
                search: {
                    ...prevValue.search,
                    searchValue: null,
                },
            }));
        }
    };

    handleSubmitSearch = async () => {
        try {
            this.handleTriggerLoading();
            let paramFilters = {
                kodeVariant: this.props.selectedData.kodeVariant,
                kodeWarna: this.props.selectedData.kodeWarna,
                locator: this.props.selectedData.kodeLokasi,
                idWarna: this.props.selectedData.idWarna,
            };

            let {searchKey, searchValue} = this.state.search;
            if (!R.isNil(searchKey) && !R.isEmpty(searchKey)) {
                paramFilters[searchKey] = searchValue;
            }

            await this.fetchDataUnitInfo({
                paramFilters: removeNullFields(paramFilters),
                limit: 5,
                page: 1
            });
        } catch (error) {
            console.log("errors: ", error);
        } finally {
            this.handleTriggerLoading();
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataUnitInfo = async (body) => {
        try {
            let response = await Api.create("NAGAMAS_TRANSACTION").getInventoryUnitDetailByParam(
                body && Object.keys(body).length > 0
                    ? body :
                    {
                        paramFilters: {},
                        page: 1,
                        limit: 5,
                    }
            );
            if (response.ok && response.data?.data) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataTable: response.data.data,
                    pagination: {
                        ...prevState.pagination,
                        count: response.data.data.length,
                    }
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title="Detail Inventory Unit"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <div className="grid grid-3x grid-mobile-none gap-20px margin-bottom-20px">
                                <div id="grid-1">
                                    <SimpleInput
                                        id="input_text_kode_variant"
                                        name="kodeVariant"
                                        label="Kode Varian"
                                        readOnly={true}
                                        value={this.props.selectedData.kodeVariant}
                                    />
                                    <SimpleInput
                                        id="input_text_nama_variant"
                                        name="namaVariant"
                                        label="Nama Varian"
                                        readOnly={true}
                                        value={this.props.selectedData.namaVariant}
                                    />
                                </div>

                                <div id="grid-2">
                                    <SimpleInput
                                        id="input_text_kode_warna"
                                        name="kodeWarna"
                                        label="Kode Warna"
                                        readOnly={true}
                                        value={this.props.selectedData.kodeWarna}
                                    />
                                    <SimpleInput
                                        id="input_text_nama_warna"
                                        name="namaWarna"
                                        label="Nama Warna"
                                        readOnly={true}
                                        value={this.props.selectedData.namaWarna}
                                    />
                                </div>

                                <div id="grid-3">
                                    <SimpleInput
                                        id="input_text_locator"
                                        name="namaLokasi"
                                        label="Locator"
                                        readOnly={true}
                                        value={this.props.selectedData.namaLokasi}
                                    />
                                </div>
                            </div>

                            <FlexView style={{justifyContent: "flex-end", gap: "10px"}}>
                                <FlexView>
                                    <SimpleDDL
                                        id="select_options_noka_nosin"
                                        box="search"
                                        name="searchKey"
                                        containerclassname="width width-250px"
                                        placeholder="Noka/Nosin"
                                        menuPosition="fixed"
                                        isClearable={true}
                                        options={[
                                            {label: "Noka", value: "noRangka"},
                                            {label: "Nosin", value: "noMesin"},
                                        ]}
                                        onChange={(value, {name}) => this.handleOnValueChange(name, value ? value.value : null)}
                                    />
                                </FlexView>
                                <FlexView>
                                    <SimpleInput
                                        id="input_text_search"
                                        name="searchValue"
                                        className="txt txt-sekunder-color"
                                        type="text"
                                        value={this.state.search.searchValue}
                                        onChange={({target}) => this.handleOnValueChange(target.name, target.value)}
                                    />
                                    <SimpleButton
                                        secondary
                                        styles={{width: "unset", marginLeft: "2px"}}
                                        className="margin-top-5px"
                                        icon={<i style={{fontSize: 24}} className="fa fa-lg fa-search"></i>}
                                        onClick={this.handleSubmitSearch}
                                    />
                                </FlexView>
                            </FlexView>
                            <SimpleDataTable
                                key={`${this.state.pagination.count}-${this.state.pagination.page}`}
                                title="Unit Info"
                                data={this.state.dataTable}
                                columns={this.tableConfig}
                                rowsPerPage={this.state.pagination.limit}
                                toCount={this.state.pagination?.count}
                                page={this.state.pagination.page - 1}
                                options={{
                                    ...defaultTableChange( this.handleChangePage, this.handleRowsPerPage ),
                                    serverSide: false,
                                }}
                            />
                            <div style={{textAlign: "right", marginTop: "10px"}}>
                                <SimpleButton
                                    onClick={() => this.props.onClickClose()}
                                    text={"Keluar"}
                                />
                            </div>
                        </ModalContainer>
                    }
                />

                {this.state.historyModalVisible && (
                    <InventoryUnitDetailHistory
                        selectedData={this.state.selectedData}
                        visible={this.state.historyModalVisible}
                        onClickClose={this.handleModalHistoryVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default InventoryUnitDetail;